export default function ($translate) {
    return {
        KEYS: {
            READ: 'READ',
            NOT_READ: 'NOT_READ'
        },
        LABELS: {
            READ: $translate.instant('notification.Read'),
            NOT_READ: $translate.instant('notification.Not read')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/notification/status/index.js